import { inject, observer, Provider } from "mobx-react";
import React, { Component } from "react";
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { compose } from "recompose";

import { Auth0 } from "nvent-web/services/Auth0";
import { NotificationsStore } from "nvent-web/stores/Notifications";

import { LoginFlow } from "../stores/LoginFlow";
import { ForgotPasswordPage } from "./components/ForgotPasswordPage";
import LoginPage from "./components/LoginPage";

export interface LoginInnerProps extends RouteComponentProps<{}> {
  auth0: Auth0;
  notifications: NotificationsStore;
}

export class LoginInner extends Component<LoginInnerProps> {
  private login = new LoginFlow(this.props.auth0, this.props.history, this.props.notifications, this.props.match.url);

  render() {
    const { path, url } = this.props.match;

    return (
      <Provider login={this.login}>
        <Switch>
          <Route path={path} exact={true} component={LoginPage} />
          <Route path={`${path}/forgot-password`} exact={true} component={ForgotPasswordPage} />
          <Redirect to={url} />
        </Switch>
      </Provider>
    );
  }
}

export const Login = compose<LoginInnerProps, {}>(
  inject("auth0", "notifications"),
  withRouter,
  observer
)(LoginInner);
export default Login;
